import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Tauri bridge proxy — only exists inside the desktop/mobile app.
// In a plain browser window.__TAURI__ is undefined, so the bridge is never
// installed and the "Launch" button is not rendered (see TunnelCard.jsx).
const w = window as any;
const isTauri = !!(w.__TAURI__ || w.__TAURI_INTERNALS__);
if (isTauri) {
  // Dynamic import keeps the plain-browser bundle from executing Tauri code.
  // @tauri-apps/api is bundled but only invoked inside the Tauri WebView.
  const invokeTauri = async (cmd: string, args: Record<string, unknown>) => {
    const mod = await import('@tauri-apps/api/core');
    return mod.invoke(cmd, args);
  };

  type LaunchArgs = {
    id: string;
    access_token: string;
    local_port: number;
    local_ip?: string;
    nodes?: unknown[];
    public_host?: string;
  };

  w.TunnelBridge = {
    launch: (t: LaunchArgs) => invokeTauri('launch_tunnel', { args: t }),
    stop: (tunnelId: string) => invokeTauri('stop_tunnel', { tunnelId }),
  };
  // Backward-compat alias so existing TunnelCard calls keep working.
  w.FlutterBridge = w.TunnelBridge;
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container element with id "root" not found');
}

const root = ReactDOM.createRoot(container as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

